<template>
<span>
  <span  v-if='form_mode' class='edit'>
    <div v-if="component" :is="component" v-bind="component_bind" :value='value' @input='$emit("input",$event)' :parent="parent" :choices='choices' ></div>
    <input v-else-if='type=="BooleanField"' type='checkbox' :value="value" @input='$emit("input", $event.target.checked)' />
    <select v-else-if='choices' :value='value' @input='$emit("input",$event.target.value)' :required="required" @change='$emit("change", $event.target.value)'>
      <option v-for='c in choices' :value='c[choice_key]'>{{c[choice_val]}}</option>
    </select>
    <date-picker v-else-if="type === 'DateField'" :required="required" :value='value' @input='$emit("input", $event)' />
    <textarea v-else-if="type === 'TextField'" :value='value' @input='$emit("input", $event.target.value)' :required="required"></textarea>
    <input v-else-if='type === "DateTimeField"' type="datetime-local" :value="moment(local).format('YYYY-MM-DDTHH:mm:ss')" @input="$emit('input', moment($event.target.value).format())" :required="required" step="1" />    
    <input v-else type="text"  :value='value' @input='$emit("input",$event.target.value)' :required="required"  :maxlength="max_length" />
    <!-- {{type}} -->
  </span>
  
  <span  v-else-if='edit_mode' class='edit'>
    <div v-if="component" :is="component" v-bind="component_bind" v-model='local' :parent='parent' :choices='choices'></div>
    <input v-else-if='type==="BooleanField"' type='checkbox' v-model='local' />
    <select v-else-if='choices' v-model='local'>
      <option v-for='c in choices' :value='c[choice_key]'>{{c[choice_val]}}</option>
    </select>
    <div v-else-if="type=='TextField'"><textarea  v-model='local'></textarea></div>
    <date-picker v-else-if="type === 'DateField'" :required="required" :value='local'  @input='local = $event' />
    <input v-else-if='type === "DateTimeField"' type="datetime-local" :value="local === null ? null : moment(local).format('YYYY-MM-DDTHH:mm:ss')" @input='local=moment($event.target.value).format()' step="1" />
    <input v-else type="text" v-model='local' @keyup.enter='$emit("input", local); edit_mode=false' @keyup.escape='edit_mode=false'  :maxlength="max_length" />
    <div class='icon small outline' @click='$emit("input", local); edit_mode=false'>
      <img src='@/assets/icons/check.svg' />
    </div>
    <div class='icon small outline' @click='edit_mode=false'>
      <img src='@/assets/icons/cancel.svg' />
    </div>    
  </span>
  
  <span v-else @click='edit_mode=true && really_editable' :class='{static: really_editable}'>
    <div v-if='display' :is="display" :value="value" display v-bind='component_bind' :parent='parent' :choices='choices'></div>
    <div v-else-if='type === "TextField"' class='textfield-div'>{{ value }}</div>
    <span v-else-if='type === "DateField"'>
      {{ moment(value).format('L') }}
    </span>
    <span v-else-if='type === "DateTimeField"'>
      {{ value === null ? "" : moment(value).format('lll') }}
    </span>
    <span v-else >
      {{ get_display_value() }}
    </span>
    <img v-if='really_editable' class='pencil' title='Edit' src='@/assets/icons/pencil.svg' />
  </span>
</span>
  
</template>


<script>
import DatePicker from '@/components/DatePicker.vue'
import Accounts from '@/components/Accounts.vue'
import Currency from '@/components/Currency.vue'
import User from '@/components/User.vue'

export default {
    components : {
	Accounts, Currency, User, DatePicker
    },
    props: {
	type  : {
	    type: String
	},
	value : {
	    type: [String, Number, Object, Boolean, Date]
	},
	parent: {
	    type: Object
	},
	choices: {
	    type: Array,
	    default: null
	},
	initial: {
	    type: Object,
	    default: null
	},	
	editable: {
	    type: Boolean,
	    default: true
	},
	can_edit: {
	    type: Boolean,
	    default: true
	},
	choice_key: {
	    type: [String, Number],
	    default: "id"
	},
	choice_val: {
	    type: [String, Number],
	    default: "name"
	},
	form_mode: {
	    type: Boolean
	},
	required: {
	    type: Boolean
	},
	show_null: {
	    type: Boolean
	},
	component: {
	    type: String
	},
	display: {
	    type: String
	},
	component_bind: {
	    type: Object
	},
	max_length: {
	    type: Number
	},
    },
    computed: {
	really_editable: function() {
	    return this.editable && this.can_edit
	}
    },
    data: function() {
	return {
	    edit_mode: false,
	    local: "",
	    expanded: false,
	}
    },
    methods: {
	get_display_value: function() {
	    var v = this.value
	    if(v === null || v === undefined || v === "") {
		if(this.show_null) {
		    return 'None'
		} else {
		    v=''
                }
	    } else if(this.component_bind !== undefined && this.component_bind.items !== undefined) {
                var x = this.component_bind.items.find(i => i.id == v)
		if(x) {
		    return x.full
		} else {
		    return "?"
		}
	    } else if(this.choices !== null && this.choices !== undefined) {
		try {
		    var x = this.choices.find(c => c[this.choice_key] === this.value)
		    if(x) {
			v = x[this.choice_val]
		    } else {
			v = "?"
		    }
		    if(v===undefined) {
			v = this.value
		    }
		} catch(e) {
		    v = "?"
		}
	    } else if(this.type === 'BooleanField') {
		v = v ? "X" : ""
	    }
	    return v
	},
    },
    mounted: function() {
	this.local = this.value
	if(this.type === "BooleanField") {
	    if(this.value === null) {
		this.$emit('input', false)
	    }
	}
    },
    watch: {
	value: function() {
	    this.local = this.value
	},
	edit_mode: function() {
	    if(!this.edit_mode)
		this.local = this.value
	}
    },
}
  
</script>


<style scoped>

.icon {
    margin: 0 2px;
}
.static {
    cursor: pointer;
}
.static:hover {
    text-decoration: underline;
}
input {
    width: unset;
    border-radius: 3px;
    border: 1px solid #888
}
select, input {
    height: 36px;
}
.pencil {
    height: 1.0em;
    opacity: 0.25;
    margin-left: 2px;
}
.pencil:hover {
    opacity: 1.0;
}
input[type=checkbox] {
    height: 20px !important;
    width: 20px !important;
}
textarea {
    width: 100%;
    height: 100px;
}
.textfield-div {
    white-space: pre-wrap;
    overflow: auto;
    max-height: 100px
}
.edit input {
    width: 100%;
}

</style>
